import { render, staticRenderFns } from "./IframeVideoPlayer.vue?vue&type=template&id=6633eb1a&scoped=true&"
import script from "./IframeVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./IframeVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./IframeVideoPlayer.vue?vue&type=style&index=0&id=6633eb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633eb1a",
  null
  
)

export default component.exports